import { PlanReference } from "../../models";

export const bulkAssignAccounts = async (
  API_URL: string,
  employerId: string,
  token: string | undefined,
  selectedPlan: PlanReference,
  targetEmployeeIds: string[]): Promise<string> => {
    const response = await fetch(
      `${API_URL}/employers/${employerId}/employees/accounts`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          employeeIds: targetEmployeeIds,
          plans: [{...selectedPlan, employerModuleType: selectedPlan.employerModuleOptions.employerModuleType}]
        })
      }
    );

    if (!response.ok) {
      throw new Error("There was a problem assigning these plans");
    }

    const responseBody = await response.json();
    return responseBody.jobId;
  }